import { render } from "./UsuarioEditPage.vue?vue&type=template&id=3f25c808"
import script from "./UsuarioEditPage.vue?vue&type=script&lang=js"
export * from "./UsuarioEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__